module.exports = __webpack_public_path__ + "static/media/linkedin_dp_overlay_round_repos.dac1ef79.png";